import {
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { useUnit } from "effector-react";
import { authenticationStore } from "@state/auth/AuthStore";
import { useEffect, useMemo, useState } from "react";
import { requestGetUserInfo } from "@state/auth/AuthEffects";
import { setUser } from "@state/auth/AuthEvents";
import { ParsedResponse } from "@utils/rest/ServerResponseParse";
import { CALLBACK_URL_PARAM } from "@utils/Constant";
import { ROUTES } from "@routes/Routes";
import { officeService } from "@services/officeService";
import { ActiveUser, AuthenticationContext } from "@type/core/auth/auth.types";

const AuthLayout = (): JSX.Element => {
  const location = useLocation();
  const navigate = useNavigate();
  const authStore = useUnit<AuthenticationContext | null>(authenticationStore);
  const [userLoaded, setUserLoaded] = useState<boolean>(false);
  const loginRedirect = useMemo(
    () =>
      `${ROUTES.auth.login.generate()}?${CALLBACK_URL_PARAM}=${
        location.pathname
      }`,
    [location],
  );

  useEffect(() =>
    requestGetUserInfo.done.watch(
      ({ result }: { result: ParsedResponse<ActiveUser> }) => {
        if (result.ok && result.data) {
          setUser(result.data);
        } else if (result.responseCode !== 500) {
          navigate(loginRedirect);
        } else {
          navigate(ROUTES.maintenance.generate());
        }
        setUserLoaded(true);
      },
    ),
  );

  useEffect(() => {
    setUserLoaded(false);
    void requestGetUserInfo({});
  }, []);

  if (userLoaded) {
    return !authStore?.user ||
      officeService.getAccessibleOffices(authStore.user).length === 0 ? (
      <Routes>
        <Route path="/*" element={<Navigate to={loginRedirect} />} />
      </Routes>
    ) : (
      <Outlet />
    );
  } else {
    return <></>;
  }
};

export default AuthLayout;
